import React from "react";
import { Route } from "react-router-dom";
import loadable from "@loadable/component";
import { PageLoader } from "GlobalComponent/PageLoader";
import { page } from "GlobalEnum/Page";
import { Pages } from "GlobalEnum/NewPage.js";

const Mileage = loadable(
  () => import(/* webpackChunkName: "mileage" */ "../containers/Mileage.js"),
  {
    fallback: <PageLoader />,
  }
);
export const MileageRoute = (
  <Route
    exact
    path={
      "/:makeMaskingName([a-zA-Z0-9_-]+)-cars/:modelMaskingName([a-zA-Z0-9_-]+)/mileage/"
    }
    render={props => {
      return (
        <Mileage
          {...props}
          pageId={page.MILEAGE_MSITE.id}
          newPageId={Pages.MILEAGE_PAGE.id}
          isMobile
        />
      );
    }}
    key="mileage"
  />
);
export const DesktopMileageRoute = (
  <Route
    exact
    path={
      "/:makeMaskingName([a-zA-Z0-9_-]+)-cars/:modelMaskingName([a-zA-Z0-9_-]+)/mileage/"
    }
    render={props => {
      return (
        <Mileage
          {...props}
          pageId={page.MILEAGE_DESKTOP.id}
          newPageId={Pages.MILEAGE_PAGE.id}
          isMobile={false}
        />
      );
    }}
    key="mileage"
  />
);
